import { ChoiceGroup, IChoiceGroupOption, Stack, Text } from "@fluentui/react";
import { ITheme, useTheme } from "cayo.ui";
import React, { FC, useCallback, useMemo } from "react";
import styled from "styled-components";
import { EditModes } from "./types";

type EditModeSwitchProps = { mode: EditModes; setMode: (mode: EditModes) => void };

const EditModeSwitch: FC<EditModeSwitchProps> = ({ setMode, mode }) => {
  const { cayoTheme } = useTheme();
  const { brandColors } = cayoTheme;

  const renderLabel = useCallback((o: IChoiceGroupOption, color: string) => {
    return (
      <Stack horizontal verticalFill verticalAlign="center" styles={{ root: { marginLeft: 28 } }}>
        <Square bgcolor={color} />
        <Text variant="small">{o.text}</Text>
      </Stack>
    );
  }, []);

  const options = useMemo<IChoiceGroupOption[]>(() => {
    return [
      {
        key: "allowed",
        text: "Allowed",
        value: "allowed",

        onRenderLabel: (p) => renderLabel(p!, brandColors.primaryHighlight),
      },
      {
        key: "blocked",
        text: "Blocked",
        value: "blocked",
        onRenderLabel: (p) => renderLabel(p!, brandColors.primaryBackground),
      },
    ];
  }, []);

  return (
    <ChoiceGroup
      styles={{
        flexContainer: {
          display: "flex",
          width: "100%",
          justifyContent: "center",
          columnGap: "8px",
        },
        root: {
          flex: 1,
          ".ms-ChoiceFieldLabel": {
            fontSize: 13,
          },
          ".ms-ChoiceField": {
            marginTop: 0,
          },
          ".ms-ChoiceField-field": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      }}
      options={options}
      defaultSelectedKey={mode}
      onChange={(ev, o) => setMode(o!.key! as EditModes)}
    />
  );
};

const Square = styled.div<{ bgcolor: string }>`
  width: 16px;
  height: 16px;
  border: 1px solid ${(props) => (props.theme as ITheme).cayoTheme.brandColors.divider};
  background-color: ${(props) => props.bgcolor};
  margin-right: 4px;
`;

export default EditModeSwitch;
